import { combineReducers } from 'redux';
import {
	authLoading,
	currentUser,
	authorisation,
	tokens,
	//fetchTokensInProgress,
} from 'pages/auth/reducers.js';

import {
	clientId,
	clientIds,
	clientIdsLoaded,
} from 'components/clientSessionSelect/clientSelect/reducers.js';
import { weighers, weighersLoaded } from 'components/weighers/reducers.js';
import { timezones, timezonesLoaded } from 'components/timezones/reducers.js';
import { messages } from 'components/messages/reducers.js';
import { next_path, prev_path } from 'components/utils/reducers.js';
import {
	session,
	sessionIds,
} from 'components/clientSessionSelect/sessionSelect/reducers.js';

import { sessionSummary } from 'components/sessionSummary/reducers.js';
import { DefCurrentUser } from 'pages/auth/actions.js';

export const initialState = {
	// 	...initialStateShop,
	authLoading: false,
	authorisation: [],
	clientId: 0,
	clientIds: [],
	clientIdsLoaded: false,
	currentUser: DefCurrentUser,
	//fetchTokensInProgress: false,
	messages: [],
	next_path: '',
	prev_path: '',
	session: { SessionID: '0' },
	sessionIds: [],
	sessionSummary: {},
	tokens: {},
	weighers: [],
	weighersLoaded: false,
};

export const rootReducer = combineReducers({
	authLoading,
	authorisation,
	clientId,
	clientIds,
	clientIdsLoaded,
	currentUser,
	//fetchTokensInProgress,
	messages,
	next_path,
	prev_path,
	session,
	sessionIds,
	sessionSummary,
	tokens,
	weighers,
	weighersLoaded,
	timezones,
	timezonesLoaded,
});

//export default rootReducer
